import { useCallback } from "react";
import * as excel from "@script/excel.ts";
import { toast } from "@/components/toast/CustomToast";
import type { CurDate } from "@/store/scheduleStore";

type UseRosterExcelDownloadParams = {
  curDate: CurDate | null;
  scheduleId: string | undefined;
  isAdmin: boolean;
  selectedGroupId: string | null;
  currentTeamTableViewTab: number;
};

export function useRosterExcelDownload({
  curDate,
  scheduleId,
  isAdmin,
  selectedGroupId,
  currentTeamTableViewTab,
}: UseRosterExcelDownloadParams) {
  return useCallback(async () => {
    if (!curDate?.year || !curDate?.month) {
      toast.error("날짜가 누락되었습니다.");
      return;
    }

    try {
      await excel.schedule_download(
        scheduleId ?? "",
        curDate.year,
        curDate.month,
        isAdmin ? (selectedGroupId ?? undefined) : undefined,
        currentTeamTableViewTab === 1
      );
    } catch (error) {
      console.error("다운로드에 실패했습니다.", error);
      alert("다운로드에 실패했습니다.");
    }
  }, [
    curDate?.year,
    curDate?.month,
    scheduleId,
    isAdmin,
    selectedGroupId,
    currentTeamTableViewTab,
  ]);
}
